// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__rCSMx","spinner":"Dialog_spinner__w3PwM","newDialog":"Dialog_newDialog__yn6j9","modalBody":"Dialog_modalBody__o16z4"};